import Hero from "../components/Hero";
import ClientMarquee from "../components/ClientMarquee";
import AboutSnippet from "../components/AboutSnippet";
import ServicesGrid from "../components/ServicesGrid";
import WhyChooseUs from "../components/WhyChooseUs";
import Certifications from "../components/Certifications";
import ProcessTimeline from "../components/ProcessTimeline";
import IndustriesGrid from "../components/IndustriesGrid";
import ContactSection from "../components/ContactSection";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <section id="home"><Hero /></section>
      <ClientMarquee />
      <section id="about"><AboutSnippet /></section>
      <section id="services"><ServicesGrid /></section>
      <WhyChooseUs />
      <Certifications />
      <section id="process"><ProcessTimeline /></section>
      <section id="industries"><IndustriesGrid /></section>
      <section id="contact"><ContactSection /></section>
    </main>
  );
}
